import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Modal,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import BookmarkRemoveIcon from "@material-ui/icons/RemoveCircle";
import "./accordion.scss";
import { saveBorradores } from "../../../store/actions";
import Logo_delete from "../../../../assets/icons/deletel.png";
import EditIcon from "@material-ui/icons/Edit";
import classNames from "classnames";
import { getSavedBorradores } from "../../../store/selectors";

export default function ControlledAccordions(props) {
    const {
        title,
        etiqueta,
        content,
        expandir,
        availableAction,
        borradores,
        itemId,
        item,
        itemKey,
        showDeleted,
        showOnlyDeleted,
        fnDeleteToBorrador,
        fnAddToBorrador,
        fnEditToBorrador,
    } = props;

    const [expanded, setExpanded] = useState(false);

    const username = localStorage["username"];

    const saved_borradores_selector = borradores;

    let saved_borrador_r = false;
    if (saved_borradores_selector !== undefined) {
        saved_borradores_selector.forEach((i) => {
            if (i._id === itemId) {
                saved_borrador_r = true;
            }
        });
    }

    const [borradorState, setBorradorState] = useState(saved_borrador_r);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(() => {
        if (expandir) {
            setExpanded("panel1");
        }
    }, [expandir]);

    const addToBorrador = () => {
        fnAddToBorrador(item, title);
    };

    const deleteToBorrador = () => {
        fnDeleteToBorrador(item, itemKey);
        setDeleteOpen(false);
    };

    const editToBorrador = () => {
        fnEditToBorrador(item, itemKey);
    };

    const handleDeleteClose = () => {
        setDeleteOpen(false);
        setExpanded("panel1");
    };

    return (
        <div className="accordion-item">
            <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    {title}

                    {showDeleted && (
                        <div className="accordion-actions">
                            <span
                                className="btn-edit"
                                onClick={() => editToBorrador()}
                            >
                                <div>
                                    <EditIcon />
                                </div>
                            </span>
                            <span
                                className="btn-delete"
                                onClick={() => setDeleteOpen(true)}
                            >
                                <div>
                                    <img alt="contact" src={Logo_delete}></img>
                                </div>
                            </span>
                        </div>
                    )}
                    {showOnlyDeleted && (
                        <span
                            className="btn-delete"
                            onClick={() => setDeleteOpen(true)}
                        >
                            <div>
                                <img alt="contact" src={Logo_delete}></img>
                            </div>
                        </span>
                    )}
                    {username !== undefined && availableAction && (
                        <div className="actions-accordion-borrador">
                            <button
                                id={`btn-borrador-${title}`}
                                title={
                                    availableAction === "delete"
                                        ? "Eliminar item del borrador"
                                        : "Agregar item al borrador"
                                }
                                onClick={() => {
                                    if (availableAction === "delete") {
                                        deleteToBorrador(title);
                                    } else {
                                        addToBorrador(title);
                                    }
                                }}
                            >
                                {availableAction === "delete" ? (
                                    <BookmarkRemoveIcon
                                        id={`span-${title}`}
                                        className={classNames(
                                            "borrador_icon delete"
                                        )}
                                    />
                                ) : (
                                    <LibraryBooksIcon
                                        id={`span-${title}`}
                                        className={classNames(
                                            "borrador_icon active"
                                        )}
                                    />
                                )}
                            </button>
                        </div>
                    )}
                </AccordionSummary>
                <AccordionDetails id={`ac-detail-${title}`}>
                    {content}
                </AccordionDetails>
            </Accordion>

            <Modal
                open={deleteOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="delete-borrador">
                    <div id="delete_window" className="delete_window">
                        <div className="delete-box">
                            <div className="delete-title">
                                <div>Eliminar item de borrador</div>
                                <span className="span_sub">
                                    Confirme para eliminar item del borrador 1
                                </span>
                            </div>
                        </div>
                        <div className="delete-acttions">
                            <button
                                className="btn_secondary"
                                onClick={handleDeleteClose}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn_primary"
                                onClick={() => deleteToBorrador()}
                            >
                                Eliminar
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
